const trackLandingPageViewEvent = () => {
    window.fbq('track', 'LandingPageView')
}

const trackSigninPageViewEvent = () => {
    window.fbq('track', 'SignInPageView')
}

const trackSignupPageViewEvent = () => {
    window.fbq('track', 'SignUpPageView')
}
const trackSignupButtonClickEvent = () => {
    window.fbq('track', 'SignupButtonClick')
}

const trackSignInWithGoogleButtonClickEvent = () => {
    window.fbq('track', 'SignInWithGoogle')
}

export {
    trackLandingPageViewEvent,
    trackSignupPageViewEvent,
    trackSignInWithGoogleButtonClickEvent,
    trackSignupButtonClickEvent,
    trackSigninPageViewEvent,
}